export default __webpack_public_path__ + "static/media/tourisme.25333647.svg";